import { useMemo } from "react";
import { Activity, Truck, Fuel, HardHat, AlertTriangle, CheckCircle, MessageSquare, Hand, Clock, Zap } from "lucide-react";

const EVENT_CONFIG = {
  SHIFT_START: { icon: Zap, color: "text-lime-500", bg: "bg-lime-500/10" },
  SHIFT_STOP: { icon: Clock, color: "text-slate-400", bg: "bg-slate-800" },
  PLANNER_APPROVAL: { icon: CheckCircle, color: "text-lime-500", bg: "bg-lime-500/10" },
  DRIVER_DELIVERY_COMPLETE: { icon: Fuel, color: "text-lime-400", bg: "bg-lime-500/10" },
  DRIVER_BREAK: { icon: Clock, color: "text-amber-500", bg: "bg-amber-500/10" },
  DRIVER_BREAKDOWN: { icon: AlertTriangle, color: "text-red-500", bg: "bg-red-600/10" },
  DRIVER_FEEDBACK: { icon: MessageSquare, color: "text-sky-400", bg: "bg-sky-500/10" },
  MACHINE_ALERT: { icon: HardHat, color: "text-amber-500", bg: "bg-amber-500/10" },
  MACHINE_STATUS_CHANGE: { icon: HardHat, color: "text-purple-400", bg: "bg-purple-500/10" },
  LIKE_ACTION: { icon: Hand, color: "text-amber-500", bg: "bg-amber-500/10" },
};

export default function LiveFeed({ events = [] }) {
  const recentEvents = useMemo(() => events.slice(0, 8), [events]);

  if (recentEvents.length === 0) return null;

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-md p-4" data-testid="live-feed">
      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2 mb-3">
        <Activity className="w-3.5 h-3.5 text-lime-500" /> Live Feed
      </h3>
      <div className="flex gap-3 overflow-x-auto pb-1 no-scrollbar">
        {recentEvents.map((event, i) => {
          const config = EVENT_CONFIG[event.event_type] || EVENT_CONFIG.MACHINE_ALERT;
          const Icon = config.icon;
          return (
            <div key={event.id || i}
              className={`min-w-[220px] p-3 rounded-md border border-slate-800 ${config.bg} shrink-0 animate-fadeInUp`}
              style={{ animationDelay: `${i * 0.05}s`, opacity: 0 }}>
              <div className="flex items-center gap-2 mb-1.5">
                <Icon className={`w-3.5 h-3.5 ${config.color}`} />
                <span className="text-[9px] font-bold text-slate-500 uppercase tracking-wider">{event.event_type?.replace(/_/g, " ")}</span>
              </div>
              <p className="text-[11px] font-bold text-slate-300 leading-snug line-clamp-2">{event.message}</p>
              {event.driver_name && (
                <span className="text-[9px] font-bold text-slate-600 block mt-1.5">{event.driver_name} / {new Date(event.timestamp).toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})}</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
